<template>
    <!-- 疫情相关 -->
    <div class="show" v-show="showNPC == '1'">
        <div class="npcMassage" style="display:none;" @click="hidenpcDetail()">
            <div class="massageDetail" @click.stop="nothing()">
                <div class="active">
                    <div class="leftmassage">
                        <div class="npcTitle">
                            <div class="left" :class="isAllNPV == '1'?'checked':''" @click.stop="changeChecked('1')">全国疫情实时数据</div>
                            <div class="right" :class="isAllNPV == '2'?'checked':''" @click.stop="changeChecked('2')">本地疫情实时数据<p v-if="haveMsg != '0'">({{citys}})</p></div>
                        </div>
                        <div class="detailAll">
                            <div class="haveDetail" v-if="haveMsg == '1'">
                                <div class="oneMsg">
                                    <p class="num">{{showNcpMsg.diagnosed}}</p>
                                    <p class="type">确诊</p>
                                    <div>
                                        <span class="Npcnum1">较昨日</span>
                                        <span class="Npctype1" style="color:rgba(230, 84, 42, 1);position: absolute;top:1.12rem;left: 0.64rem;" v-if="showNcpMsg.diagnosedIncr>=0">+{{showNcpMsg.diagnosedIncr}}</span>
                                        <span class="Npctype1" style="color:rgba(230, 84, 42, 1);position: absolute;top:1.12rem;left: 0.64rem;" v-if="showNcpMsg.diagnosedIncr<0">{{showNcpMsg.diagnosedIncr}}</span>
                                    </div>
                                </div>
                                <div class="oneMsg">
                                    <p class="num" style="color:rgba(244, 171, 81, 1);">{{showNcpMsg.suspect}}</p>
                                    <p class="type">疑似</p>
                                    <div>
                                        <span class="Npcnum2">较昨日</span>
                                        <span class="Npctype2" style="color:rgba(244, 171, 81, 1);position: absolute;top:1.12rem;left: 0.64rem;" v-if="showNcpMsg.suspectIncr>=0">+{{showNcpMsg.suspectIncr}}</span>
                                        <span class="Npctype2" style="color:rgba(244, 171, 81, 1);position: absolute;top:1.12rem;left: 0.64rem;" v-if="showNcpMsg.suspectIncr<0">{{showNcpMsg.suspectIncr}}</span>
                                    </div>
                                </div>
                                <div class="oneMsg">
                                    <p class="num" style="color:rgba(0, 0, 0, 1);">{{showNcpMsg.death}}</p>
                                    <p class="type">死亡</p>
                                    <div>
                                        <span class="Npcnum3">较昨日</span>
                                        <span class="Npctype3" style="color:rgba(0, 0, 0, 1);position: absolute;top:1.12rem;left: 0.64rem;" v-if="showNcpMsg.deathIncr>=0">+{{showNcpMsg.deathIncr}}</span>
                                        <span class="Npctype3" style="color:rgba(0, 0, 0, 1);position: absolute;top:1.12rem;left: 0.64rem;" v-if="showNcpMsg.deathIncr<0">{{showNcpMsg.deathIncr}}</span>
                                    </div>
                                </div>
                                <div class="oneMsg">
                                    <p class="num" style="color:rgba(0, 137, 124, 1);">{{showNcpMsg.cured}}</p>
                                    <p class="type">治愈</p>
                                    <div>
                                        <span class="Npcnum4">较昨日</span>
                                        <span class="Npctype4" style="color:rgba(0, 137, 124, 1);position: absolute;top:1.12rem;left: 0.64rem;" v-if="showNcpMsg.curedIncr>=0">+{{showNcpMsg.curedIncr}}</span>
                                        <span class="Npctype4" style="color:rgba(0, 137, 124, 1);position: absolute;top:1.12rem;left: 0.64rem;" v-if="showNcpMsg.curedIncr<0">{{showNcpMsg.curedIncr}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="noDetail" v-if="haveMsg == '0'">
                                暂无数据    
                            </div>
                        </div>
                        <div class="npcFooter">
                            <p class="npcTime" v-if="JSON.stringify(showNcpMsg) != '{}'">数据更新时间: {{showNcpMsg.date}}</p>
                            <p class="npcTime" v-if="JSON.stringify(showNcpMsg) == '{}'">数据更新时间: 暂无更新</p>
                            <p class="npcCome" v-if="JSON.stringify(showNcpMsg) == '{}'">数据来源: 各省市卫健委</p>
                            <p class="npcCome" v-if="JSON.stringify(showNcpMsg) != '{}'">数据来源: {{showNcpMsg.source}}</p>
                        </div>
                    </div>
                    <div class="rightclick" @click.stop="hidenpcDetail()">
                        <img src="../../assets/img/npcPic2.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="npcPic" @click="showNpcMassage()" v-show="showNPC == '1'">
            <img src="../../assets/img/npcPic.png" alt="">
        </div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui';
import cbct from '../../assets/js/common/base.js';
export default {
  name: 'npcPage',
  props:['showNPC','type','number'],
  data:function(){
     return{
        //是否有数据
        haveMsg:'',
        //页面展示数据
        showNcpMsg:{},
        //全国
        allNcpMsg:{},
        //城市
        cityNcpMsg:{},
        citys:'',
        //是否展示全国
        isAllNPV:'1',
     }
  },

  methods:{
    //切换全国或者当地
    changeChecked:function(num){
        this.isAllNPV = num;
        if(this.isAllNPV == '1'){
            this.showNcpMsg = this.allNcpMsg;
        }else{
            this.showNcpMsg = this.cityNcpMsg;
        }
        if((JSON.stringify(this.showNcpMsg) == "{}")){
            this.haveMsg ='0';
        }else{
            this.haveMsg ='1';
            this.$nextTick(function(){
                console.log($('.Npctype1').text().length);
                if($('.Npctype1').text().length == '2'){
                    $('.Npcnum1').css('left','0.28rem');
                    $('.Npctype1').css('left','0.76rem');
                }else if($('.Npctype1').text().length == '3'){
                    $('.Npcnum1').css('left','0.24rem');
                    $('.Npctype1').css('left','0.72rem')
                }else if($('.Npctype1').text().length == '4'){
                    $('.Npcnum1').css('left','0.2rem');
                    $('.Npctype1').css('left','0.68rem')
                }

                if($('.Npctype4').text().length == '2'){
                    $('.Npcnum4').css('left','0.28rem');
                    $('.Npctype4').css('left','0.76rem');
                }else if($('.Npctype4').text().length == '3'){
                    $('.Npcnum4').css('left','0.24rem');
                    $('.Npctype4').css('left','0.72rem')
                }else if($('.Npctype4').text().length == '4'){
                    $('.Npcnum4').css('left','0.2rem');
                    $('.Npctype4').css('left','0.68rem')
                }

                if($('.Npctype3').text().length == '2'){
                    $('.Npcnum3').css('left','0.28rem');
                    $('.Npctype3').css('left','0.76rem');
                }else if($('.Npctype3').text().length == '3'){
                    $('.Npcnum3').css('left','0.24rem');
                    $('.Npctype3').css('left','0.72rem')
                }else if($('.Npctype3').text().length == '4'){
                    $('.Npcnum3').css('left','0.2rem');
                    $('.Npctype3').css('left','0.68rem')
                }

                if($('.Npctype2').text().length == '2'){
                    $('.Npcnum2').css('left','0.28rem');
                    $('.Npctype2').css('left','0.76rem');
                }else if($('.Npctype2').text().length == '3'){
                    $('.Npcnum2').css('left','0.24rem');
                    $('.Npctype2').css('left','0.72rem')
                }else if($('.Npctype2').text().length == '4'){
                    $('.Npcnum2').css('left','0.2rem');
                    $('.Npctype2').css('left','0.68rem')
                }
            })
            
        }
    },
        
    //展示疫情数据
    showNpcMassage:function(){
        // 
        this.getNcpMassage();
        $('.npcMassage').css('display','block')
        $('.npcPic').css('display','none');
        $('.massageDetail .active').animate({
            left:'0',
            top:'0',
        },250,function(){

        })
    },
    //获取疫情数据接口
    getNcpMassage:function(){
        var self = this;
        self.http.post(self.cbct.https()+'/h5/epidemic/data', self.qs.stringify({
            type:self.type,
            id:self.number
        })).then((response)=>{
            if(response.c == self.cbct.code.successRes){ 
                self.allNcpMsg = response.d.all;
                self.cityNcpMsg = response.d.city;
                self.citys = response.d.city.city;
                if(self.isAllNPV == '1'){
                    self.showNcpMsg = response.d.all;
                }else{
                    self.showNcpMsg = response.d.city;
                }
                if((JSON.stringify(self.showNcpMsg) == "{}")){
                    self.haveMsg ='0';
                }else{
                    self.haveMsg ='1';
                    this.$nextTick(function(){
                    console.log($('.Npctype1').text().length);
                    if($('.Npctype1').text().length == '2'){
                        $('.Npcnum1').css('left','0.28rem');
                        $('.Npctype1').css('left','0.76rem');
                    }else if($('.Npctype1').text().length == '3'){
                        $('.Npcnum1').css('left','0.24rem');
                        $('.Npctype1').css('left','0.72rem')
                    }else if($('.Npctype1').text().length == '4'){
                        $('.Npcnum1').css('left','0.2rem');
                        $('.Npctype1').css('left','0.68rem')
                    }

                    if($('.Npctype4').text().length == '2'){
                        $('.Npcnum4').css('left','0.28rem');
                        $('.Npctype4').css('left','0.76rem');
                    }else if($('.Npctype4').text().length == '3'){
                        $('.Npcnum4').css('left','0.24rem');
                        $('.Npctype4').css('left','0.72rem')
                    }else if($('.Npctype4').text().length == '4'){
                        $('.Npcnum4').css('left','0.2rem');
                        $('.Npctype4').css('left','0.68rem')
                    }

                    if($('.Npctype3').text().length == '2'){
                        $('.Npcnum3').css('left','0.28rem');
                        $('.Npctype3').css('left','0.76rem');
                    }else if($('.Npctype3').text().length == '3'){
                        $('.Npcnum3').css('left','0.24rem');
                        $('.Npctype3').css('left','0.72rem')
                    }else if($('.Npctype3').text().length == '4'){
                        $('.Npcnum3').css('left','0.2rem');
                        $('.Npctype3').css('left','0.68rem')
                    }

                    if($('.Npctype2').text().length == '2'){
                        $('.Npcnum2').css('left','0.28rem');
                        $('.Npctype2').css('left','0.76rem');
                    }else if($('.Npctype2').text().length == '3'){
                        $('.Npcnum2').css('left','0.24rem');
                        $('.Npctype2').css('left','0.72rem')
                    }else if($('.Npctype2').text().length == '4'){
                        $('.Npcnum2').css('left','0.2rem');
                        $('.Npctype2').css('left','0.68rem')
                    }
                })
                }
            }
        }
        ).catch((error)=>{console.log(error);})
    },
    //隐藏疫情数据
    hidenpcDetail:function(){
        $('.massageDetail .active').animate({
            left:'-5.96rem',
            top:'-2.96rem',
        },250,function(){
            $('.npcPic').css('display','block');
            $('.npcMassage').css('display','none');
        })
    },
  },
  created(){
    if(this.showNPC == '1'){
        this.getNcpMassage();
    }
    
  },
  filters:{
    
  },
}
</script>
<style scoped lang="scss">
    //疫情数据
    .npcMassage{
        width: 100%;
        height: 100%;
        z-index: 100000;
        position: absolute;
        top: 0;
        left: 0;
        .massageDetail{
            position: absolute;
            width:5.96rem;
            height: 2.96rem;
            top: 6rem;
            left: 0;
            overflow: hidden;
            .active{
                position: absolute;
                top:-2.96rem;
                left:-5.96rem;
                background:linear-gradient(90deg,rgba(43,135,255,1) 0%,rgba(75,163,255,1) 100%);
                border-radius: 0px 0.16rem 0.16rem 0px;
                width: 100%;
                height:100%;
            }
            .leftmassage{
                float: left;
                width: 5.56rem;
                height:100%;
                box-sizing: border-box;
                border-right:0.01rem solid rgba(255, 255, 255, 0.5);
                .npcTitle{
                    width: 100%;
                    height:0.92rem;
                    box-sizing: border-box;
                    overflow: hidden;
                    padding-top: .2rem;
                    div{
                        float: left;
                        width: 2.77rem;
                        line-height: 1;
                        font-size: 0.24rem;
                        color: rgba(11, 87, 185, 1);
                        p{
                            margin-top: .1rem;
                            font-size: .16rem;
                        }
                    }
                    .checked{
                        color: #fff;
                        p{
                            color:rgba(255,255,255,.6);
                        }
                    }
                    .left{
                        border-right: 0.01rem solid rgba(255, 255, 255, 0.5);
                    }
                }
                .detailAll{
                    width: 5.28rem;
                    height: 1.46rem;
                    margin-left:0.12rem;
                    .haveDetail{
                        width: 100%;
                        height:100%;
                        background: #fff;
                        .oneMsg{
                            float:left;
                            position: relative;
                            width: 1.3rem;
                            // margin: 0 0.36rem;
                            text-align: center;
                            height:100%;
                            .num{
                                font-size: 0.36rem;
                                color:rgba(230, 84, 42, 1);
                                line-height: 1;
                                padding: 0.26rem 0 0.06rem 0;
                            }
                            .type{
                                font-size: 0.24rem;
                                -webkit-transform-origin-x: 0; //缩小后文字居左
                                -webkit-transform: scale(0.9166);   //关键
                                color:rgba(0, 0, 0, 0.6);
                                line-height: 1;
                                padding: 0.05rem 0 0.05rem 0;
                            }
                            div{
                                margin-top:0.1rem;
                                width:100%;
                                height:0.22rem;
                                overflow: hidden;
                                span{
                                    position: absolute;
                                    top:1.12rem;
                                    left: 0.16rem;
                                    margin:0;
                                    line-height: 1;
                                    font-size: 0.24rem;
                                    -webkit-transform-origin-x: 0; //缩小后文字居左
                                    -webkit-transform: scale(0.66667);   //关键
                                    color: rgba(0, 0, 0, 0.46);
                                }
                            }
                        }
                    }
                    .noDetail{
                        width: 100%;
                        height:100%;
                        font-size:0.28rem;
                        font-weight:500;
                        color:rgba(19,100,205,0.76);
                        line-height:1;
                        padding-top: 0.54rem;
                    }
                }
                .npcFooter{
                    width: 5.28rem;
                    // height: 1.54rem;
                    height:0.1rem;
                    margin:0 0 0 0.12rem;
                    position: relative;
                    .npcTime{
                        position: absolute;
                        left:0;
                        font-size: 0.24rem;
                        -webkit-transform-origin-x: 0; //缩小后文字居左
                        -webkit-transform: scale(0.75);//关键
                        line-height: 1;
                        margin:0.14rem 0;
                        color:#fff;
                    }
                    .npcCome{
                        position: absolute;
                        right: -0.27rem;
                        font-size: 0.24rem;
                        -webkit-transform-origin-x: 360; //缩小后文字居左
                        -webkit-transform: scale(0.75);//关键
                        line-height: 1;
                        margin:0.14rem 0;
                        color:#fff;
                    }
                }
            }
            .rightclick{
                float: left;
                width: 0.4rem;
                height:100%;
                box-sizing: border-box;
                img{
                    float: left;
                    margin-left: 0.1rem;
                    margin-top:1.26rem;
                    width:0.2rem;
                    height:0.2rem;
                }
            }
        }
    }
    .npcPic{
        position: fixed;
        width:0.6rem;
        height: 1.18rem;
        top: 6rem;
        left: 0;
        z-index: 10000;
        img{
            width:100%;
            height:100%;
        }
    }
</style>

